<template>
  <div class="wrapper">
    <p v-if="!getReAuth" class="title-for-integration">
      {{ $t("integrations.newIntegrationFor") }} {{ getModalInfo.name }}
    </p>
    <p v-if="getReAuth" style="margin-inline-start: -10px" class="title">
      Re-authenticate
    </p>

    <div class="content main-error">
      <div v-for="(error, index) in getResponseErrors" :key="index">
        <div class="generalErr" v-if="error.general_error && submitted">
          <span class="error-value">{{ error.message }}</span>
        </div>
      </div>
      <div
        class="generalErr"
        v-if="submitted && getResponseErrors && getResponseErrors.message"
      >
        <span class="error-value">{{ getResponseErrors.message }}</span>
      </div>
      <div v-for="(el, index) in dir_array" :key="index">
        <InputSettings
          :element="el"
          :index="index"
          :submitted="submitted"
          :errors="getResponseErrors"
          :getReAuth="getReAuth"
        />
      </div>
    </div>
    <!-- action btns  -->
    <hr class="vertical-line" />
    <div class="modal-actions-btns">
      <VpButton
        v-if="!getReAuth"
        :text="$t('common.add')"
        :disabled="
          getLoading ||
          dir_array.find((item) => !item.value) ||
          getResponseErrors
            ? true
            : false
        "
        :isLoading="getLoading"
        @click="onSubmit()"
      />

      <VpButton
        v-if="getReAuth"
        :text="$t('common.authenticate')"
        :width="getLoading ? '150px' : '112px'"
        :disabled="getLoading"
        :isLoading="getLoading"
        @click="onSubmit()"
      />

      <VpButton
        :text="$t('common.cancel')"
        :width="getReAuth ? '130px' : '112px'"
        :isDanger="true"
        @click="$bvModal.hide('addIntegration')"
      />
    </div>
  </div>
</template>

<script>
import InputSettings from "./InputSettings";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    InputSettings,
  },
  data: function () {
    return {
      submitted: false,
      apiObjec: [],
      dir_array: [],
      errors: {},
      requiredErro: false,
      configData: [],
    };
  },

  methods: {
    ...mapActions("integration", [
      "createIntegration",
      "reAuthIntegration",
      "createConfigData",
      "resetNoGroups",
      "setIsExtraScenario",
      "getIntegration",
    ]),
    onSubmit() {
      this.submitted = true;
      for (var index = 0; index < this.dir_array.length; index++) {
        if (!this.dir_array[index].value) {
          this.requiredErro = true;
        } else {
          this.requiredErro = false;
        }
      }
      if (!this.requiredErro) {
        const obj = {};
        this.apiObjec = this.dir_array.map((item) => {
          obj[item.key_code] = item.value;
        });
        if (this.getIsExtraScenario) {
          obj.dir_int_id = this.getIntegId;
        }
        this.getReAuth
          ? this.reAuthIntegration({
              directory_type: this.getModalInfo.code,
              obj,
              integId: this.getIntegId,
            })
          : this.createIntegration({
              directory_type: this.getModalInfo.code,
              obj,
              isExtraScenario: this.getIsExtraScenario,
            });
        this.configData = this.dir_array.map((item) => {
          return {
            key_id: item.id,
            value: item.value,
            key_code: item.key_code,
          };
        });
        console.log("this.configData", this.configData);
        this.createConfigData(this.configData);
      }
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("integration", [
      "getLoading",
      "getModalState",
      "getResponseErrors",
      "getReAuth",
      "getIntegId",
      "getIntgDataMapping",
      "getNoGroups",
      "getIsExtraScenario",
      "getIntgData",
    ]),
  },
  watch: {
    getModalState(state) {
      console.log("watch", state);
      state == true && this.$bvModal.hide("addIntegration");
    },
  },
  mounted() {},
  async beforeMount() {
    this.resetNoGroups(false);
    const { dir_keys } = this.getModalInfo;
    let extraScenarioConfigs;
    if (this.getIsExtraScenario) {
      await this.getIntegration({ id: this.getIntegId });
      extraScenarioConfigs = this.getIntgData.configs;
    }
    this.dir_array = dir_keys.map((item) => {
      const currentExtraScenarioConfig = this.getIsExtraScenario
        ? extraScenarioConfigs.find((config) => config.key_id == item.id)
        : null;
      return {
        key_code: item.key_code,
        originalValue: this.getReAuth
          ? this.getIntgDataMapping.configs.find(
              (config) => config.key_id == item.id
            ).value
          : this.getIsExtraScenario && currentExtraScenarioConfig
          ? currentExtraScenarioConfig.value
          : null,
        value: this.getReAuth
          ? this.getIntgDataMapping.configs.find(
              (config) => config.key_id == item.id
            ).value
          : this.getIsExtraScenario && currentExtraScenarioConfig
          ? currentExtraScenarioConfig.value
          : null,
        is_invalid: this.getReAuth
          ? this.getIntgDataMapping.configs.find(
              (config) => config.key_id == item.id
            ).is_invalid
          : 0,
        editable: item.editable ? item.editable : 0,
        name: item.key_name,
        key_type: item.key_type,
        id: item.id,
        validation: {
          required: true,
        },
      };
    });
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/modal.scss";
</style>
<style lang="scss">
div#addIntegration {
  div#addIntegration___BV_modal_content_ {
    width: 579px;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 26px;
    margin-top: 100px;
    div#addIntegration___BV_modal_body_ {
      .title-for-integration {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        margin-bottom: 40px;
        text-align: center;
        color: #000000;
      }
      .wrapper .content .input-wrapper {
        width: 415px;
        margin: auto;
        .form-group.m-d-gruop {
          margin-bottom: 0px !important;
        }
        span.error-value {
          color: yellow !important;
        }
      }
    }
  }
}
div#extraScenario {
  div#extraScenario___BV_modal_content_ {
    width: 579px;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 26px;
    div#extraScenario___BV_modal_body_ {
      div#notes {
        height: 124px;
      }
      .request-token-title {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        margin-bottom: 40px;
        text-align: center;
        color: #000000;
      }
      .wrapper .content .input-wrapper {
        width: 415px;
        margin: auto;
        .form-group.m-d-gruop {
          margin-bottom: 0px !important;
        }
      }
    }
  }
}
</style>
